import { useEffect, useState, useRef } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import moment from "moment"
import * as customerApis from "../../utilities/apis/customer"
import Layout from "../../components/Layout"
import Pagination from "../../components/Pagination"

const Customers = () => {
  const navigate = useNavigate()
  const { token, user, permissions } = useSelector(state => state.user)
  const [customers, setCustomers] = useState([])
  const [active, setActive] = useState(1)
  const [count, setCount] = useState(0)
  const mobileRef = useRef(null)
  const [filters, setFilters] = useState({
    offset: 0,
    limit: 10,
  })

  const handleNew = () => {
    navigate("/dashboard/customer")
  }

  const handleEdit = (id) => {
    navigate(`/dashboard/customer?id=${id}`)
  }

  const handleSearch = () => {
    const where = {}

    if (mobileRef.current.value) where.mobile = mobileRef.current.value

    setFilters({ ...filters, offset: 0, ...where })
    setActive(1)
  }

  const handleReset = () => {
    setFilters({limit: 10, offset: 0})
    mobileRef.current.value = ''
    setActive(1)
  }

  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Are you sure you want to delete?")) return

      const response = await customerApis.deleteCustomer(token, id)
      if (!response.status) throw new Error(response.message)

      setCustomers((previous) => {
        const customers = previous.filter(x => x.id !== id)
        return [...customers]
      })
    } catch (error) {
      alert(error.message)
    }
  }

  const getCustomers = async () => {
    try {
      const query = new URLSearchParams(filters)
      const response = await customerApis.getCustomers(token, query.toString())
      if (!response.status) throw new Error(response.message)

      setCount(response.count)
      setCustomers(response.customers)
    } catch (error) {
      alert(error.message)
    }
  }

  const handlePageChange = (page, offset) => {
    setFilters({ ...filters, offset })
    setActive(page)
  }

  useEffect(() => {
    if (!user) navigate("/")

    getCustomers()
  }, [])

  useEffect(() => {
    getCustomers(filters)
  }, [filters])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main id="customers" className="my-2">
        <div className="container-fluid">
          <div className="row">
            <div className="col-6">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h3 className="fw-bold m-0">Customers</h3>
              </div>
            </div>
            <div className="col-3"/>
            <div className="d-flex mb-3 col-3 gap-2">
              <input ref={mobileRef} type="text" className="form-control" id="mobile" placeholder="Mobile #" required autoFocus />
              <button type="button" className="btn btn-sm btn-light text-primary" onClick={handleSearch}><i className="fas fa-search"></i></button>
              <button type="reset" className="btn btn-sm btn-light text-danger" onClick={handleReset}><i className="fas fa-times"></i></button>
              {(permissions["CREATE_CUSTOMER"]) && (<button className="btn btn-primary" onClick={() => handleNew()}>New</button>
              )}
            </div>
          </div>
        </div>
        <table className="table table-bordered table-hover shadow-none">
          <thead className="table-light">
            <tr>
              <th scope="col" style={{ width: "8%" }} className="align-middle text-center">ID</th>
              <th scope="col" style={{ width: "12%" }} className="align-middle">Name</th>
              <th scope="col" style={{ width: "12%" }} className="align-middle">Mobile #</th>
              <th scope="col" style={{ width: "25%" }} className="align-middle">Address</th>
              <th scope="col" style={{ width: "11%" }} className="align-middle">Last Order</th>
              <th scope="col" style={{ width: "11%" }} className="align-middle">Tags</th>
              <th scope="col" style={{ width: "11%" }} className="align-middle">Zone</th>
              <th scope="col" style={{ width: "10%" }} className="align-middle text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((row, index) => (
              <tr key={row.id.toString()}>
                <td className="align-middle text-center">{(index + 1) + ((active - 1) * filters.limit)}</td>
                <td className="align-middle">{row.name || "Customer"}</td>
                <td className="align-middle">{row.mobile}</td>
                <td className="align-middle">{row.address}</td>
                <td className="align-middle">{row.last_order && moment(row.last_order).format("DD-MM-YYYY")}</td>
                <td className="align-middle">{row.tags}</td>
                <td className="align-middle">{row.zone ? row.zone.name : 'N/A'}</td>
                <td className="align-middle text-center">
                  {(permissions["UPDATE_CUSTOMER"]) && (<a className="me-2" onClick={() => handleEdit(row.id)}><i className="far fa-edit"></i></a>)}
                  {(permissions["DELETE_CUSTOMER"]) && (<a className="text-danger" onClick={() => handleDelete(row.id)}><i className="far fa-trash-alt"></i></a>)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="container-fluid">
          <nav aria-label="pagination">
            <Pagination
              currentPage={active}
              totalCount={count}
              pageSize={filters.limit}
              offset={filters.offset}
              siblingCount={3}
              onPageChange={handlePageChange}
            />
          </nav>
        </div>
      </main>
    </Layout>
  )
}

export default Customers
